<ion-header>
	<app-order-page-toolbar
		(backClick)="dismiss()"
		[hideElements]="loading"
		[preorderType]="order?.preorder?.type"
		title="{{ 'payment_modal.title' | translate }}"
	></app-order-page-toolbar>
</ion-header>
<ion-content>
	<ion-row>
		<ion-col size="12">
			<h1 class="ion-margin header-msg">
				{{ 'payment_modal.message' | translate }}
			</h1>
			<div class="separator"></div>
		</ion-col>
		<ion-col size="12">
			<ion-radio-group (ionChange)="loadPayment()" [(ngModel)]="selectedPaymentMethod" [disabled]="loading">
				<ion-item *ngFor="let method of paymentMethods" [disabled]="loading" class="payment-method-row" lines="none">
					<ion-label>{{ method | translate }}</ion-label>
					<ion-radio  [value]="method" slot="start"></ion-radio>
					<ion-icon class="icon-size" size="large" slot="end" src="/assets/icon/{{ method }}.svg"></ion-icon>
				</ion-item>
			</ion-radio-group>

			<ng-container *ngIf="selectedPaymentMethod === pm.ADYEN">
				<div id="customCard-container">
					<label>
						<span>Card number:</span>
						<span class="input_data" data-cse="encryptedCardNumber"></span>
					</label>
					<label>
						<span>Expiry date:</span>
						<span class="input_data" data-cse="encryptedExpiryDate"></span>
					</label>
					<label>
						<span>CVV/CVC:</span>
						<span class="input_data" data-cse="encryptedSecurityCode"></span>
					</label>
					<button id="payButton" [class.hidden]="isAdyenLoading">Pay</button>
					<ion-spinner *ngIf="isAdyenLoading"></ion-spinner>
				</div>
			</ng-container>
			<ng-container *ngIf="selectedPaymentMethod === pm.GPAY">
				<div id="gpay-container"></div>
			</ng-container>
			<ng-container *ngIf="selectedPaymentMethod === pm.APAY">
				<p>HERE</p>
				<div id="applepay-container"></div>
			</ng-container>

			<div *ngIf="selectedPaymentMethod" [class.ion-hide]="loading" class="payment-input">
				<form
					*ngIf="selectedPaymentMethod == pm.CREDIT_CARD && venue && venue.vrPaymentEnabled"
					[action]="vrUrl"
					class="paymentWidgets"
					data-brands="MASTER VISA"
				></form>
				<div
					*ngIf="selectedPaymentMethod == pm.CREDIT_CARD && !venue.vrPaymentEnabled && venue.ppFullIntegrationEnabled"
					id="paypal-cc-button"
				></div>
				<form *ngIf="selectedPaymentMethod == pm.GPAY" [action]="vrUrl" class="paymentWidgets" data-brands="GOOGLEPAY"></form>
				<form *ngIf="selectedPaymentMethod == pm.APAY" [action]="vrUrl" class="paymentWidgets" data-brands="APPLEPAY"></form>
				<div *ngIf="selectedPaymentMethod == pm.PAYPAL" id="paypal-button"></div>
				<div *ngIf="selectedPaymentMethod == pm.WORLDLINE" class="cash-block">
					<ion-button (click)="loadWordline()" [disabled]="loadingWordline">{{ pm.WORLDLINE | translate }}</ion-button>
				</div>
				<div *ngIf="selectedPaymentMethod == pm.SOFORTBANKING" id="klarna-button"></div>
				<div *ngIf="selectedPaymentMethod == pm.CASH" class="cash-block">
					<ion-button (click)="loadCashPay()">{{ pm.CASH | translate }}</ion-button>
				</div>
				<!-- <div *ngIf="selectedPaymentMethod == pm.CCV" class="cash-block">
					<div class="payment-link" (click)="navigateCvv(payment.url)" (click)="dismiss()">
						{{ 'payment_modal.pay_with' | translate }} {{ selectedPaymentMethod | translate }}
					</div>
				</div> -->
			</div>
			<div class="separator bottom-separator"></div>
			<div *ngIf="selectedPaymentMethod == pm.CREDIT_CARD" #iframeContainer style="width: 100%; height: 100vh">
				<!-- The iframe will be dynamically inserted here -->
			</div>
		</ion-col>
	</ion-row>
	<ion-row class="ion-justify-content-center">
		<ion-spinner [class.ion-hide]="!loading"></ion-spinner>
	</ion-row>
</ion-content>
